import { BusEvacuatieDienst } from "@/entities/dossier-overzicht";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { BusEvacuatieStatus } from "./icons/busevacuatie-status";

type BusEvacuatieStatusEnTooltipProps = {
    dienst: BusEvacuatieDienst;
};

export function BusEvacuatieStatusEnTooltip({ dienst }: BusEvacuatieStatusEnTooltipProps) {
    const labels = [
        { label: "aangevraagd", count: dienst.countByStatus?.Aanvraag },
        { label: "gedeeltelijk", count: dienst.countByStatus?.Gedeeltelijk },
        { label: "intrekking aangevraagd", count: dienst.countByStatus?.AnnuleringAangevraagd },
        { label: "volledig", count: dienst.countByStatus?.Volledig },
        { label: "afgerond", count: dienst.countByStatus?.Afgerond },
        { label: "ingetrokken", count: dienst.countByStatus?.Geannuleerd },
    ];

    return (
        <Tooltip key={dienst.type}>
            <TooltipTrigger data-testid="busevacuatie-status">
                <BusEvacuatieStatus variant={dienst.variant} />
            </TooltipTrigger>
            <TooltipContent className="max-w-full">
                {labels
                    .filter(({ count }) => count && count > 0)
                    .map(({ label, count }) => (
                        <p key={label}>
                            {count} evacuatie{count === 1 ? "" : "s"} {label}
                        </p>
                    ))}
            </TooltipContent>
        </Tooltip>
    );
}
